import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchRoomSetsAPI } from "./roomSetAPI";
import { showModal } from "../statusModal/statusModal";

const initialState = {
  list: [],
  fetchStatus: "idle",
  error: null,
};

export const fetchRoomSets = createAsyncThunk(
  "roomSets/fetchRoomSets",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const data = await fetchRoomSetsAPI();
      return data;
    } catch (error) {
      dispatch(
        showModal({ message: "حصل خطأ اثناء جلب البيانات", status: "error" })
      );
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch images"
      );
    }
  }
);

const roomSetsSlice = createSlice({
  name: "roomSets",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoomSets.pending, (state) => {
        state.fetchStatus = "loading";
        state.error = null;
      })
      .addCase(fetchRoomSets.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.list = action.payload.data;
      })
      .addCase(fetchRoomSets.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload.error;
      });
  },
});

export default roomSetsSlice.reducer;
